import styled from 'styled-components';

const Badge = styled.span.withConfig({
  shouldForwardProp: (prop) => prop !== 'ownBuyer' && prop !== 'variant',
})`
  padding: 0.375rem 0.3125rem;
  border-radius: 12px;
  font-weight: bold;
  color: #fff;
  background-color: ${({ ownBuyer, theme }) => (ownBuyer ? theme.colors.success || '#28a745' : theme.colors.primary || '#007bff')};
  text-transform: uppercase;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile || '768px'}) {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
  }
`;

export default Badge;
